import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.jpg';
import hidevLogo from '../assets/hidev_logo.png';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Desktop Layout */}
        <div className="footer-desktop">
          <div className="footer-left">
            <Link to="/">
              <img src={logoImage} alt="Burbanks Logo" className="footer-logo" />
            </Link>
          </div>

          <div className="footer-center">
            <div className="footer-links">
              <Link to="/food-menu" className="footer-link">Food</Link>
              <Link to="/drink-menu" className="footer-link">Drinks</Link>
              <Link to="/music" className="footer-link">Music</Link>
              <Link to="/billiards" className="footer-link">Billiards</Link>
              <Link to="/our-story" className="footer-link">Our Story</Link>
              <Link to="/private-events" className="footer-link">Private Events</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </div>
          </div>

          <div className="footer-right">
            <a href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer">
              <img src={hidevLogo} alt="Hi Dev Logo" className="hidev-logo" />
            </a>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="footer-mobile">
          <div className="footer-mobile-top">
            <Link to="/">
              <img src={logoImage} alt="Burbanks Logo" className="footer-logo-mobile" />
            </Link>
          </div>

          <div className="footer-mobile-center">
            <div className="footer-links-mobile">
              <div className="footer-links-column">
                <Link to="/food-menu" className="footer-link-mobile">Food</Link>
                <Link to="/drink-menu" className="footer-link-mobile">Drinks</Link>
                <Link to="/music" className="footer-link-mobile">Music</Link>
                <Link to="/billiards" className="footer-link-mobile">Billiards</Link>
              </div>
              <div className="footer-links-column">
                <Link to="/our-story" className="footer-link-mobile">Our Story</Link>
                <Link to="/private-events" className="footer-link-mobile">Private Events</Link>
                <Link to="/contact" className="footer-link-mobile">Contact Us</Link>
              </div>
            </div>
          </div>

          <div className="footer-mobile-bottom">
            <a href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer">
              <img src={hidevLogo} alt="Hi Dev Logo" className="hidev-logo-mobile" />
            </a>
          </div>
        </div>

        <div className="footer-copyright">
          <p>&copy; {currentYear} Burbanks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 